// Popup newsletter -10% : appelle l'app amicaliste via le proxy /apps/loyalty.
// Cookie : { status: 'seen' | 'subscribed' }, durée réglée dans la section.
// Ajouter ?popup-newsletter=1 à l'URL pour forcer l'ouverture (test).

if (!customElements.get('perso-popup-newsletter')) {
  class PersoPopupNewsletter extends HTMLElement {
    constructor() {
      super();
      this.cookieName = 'josette_popup_newsletter';
      this.dialog = this.querySelector('[role="dialog"]');
      this.form = this.querySelector('[data-perso-popup-form]');
      this.formView = this.querySelector('[data-perso-popup-form-view]');
      this.message = this.querySelector('[data-perso-popup-message]');
      this.submitButton = this.form.querySelector('button[type="submit"]');
      this.input = this.form.querySelector('input[type="email"]');
      this.isDesignMode = this.hasAttribute('data-design-mode');
    }

    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target === this || e.target.closest('.perso-popup-newsletter__close')) this.close();
      });
      this.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') this.close();
      });
      this.form.addEventListener('submit', this.onSubmit.bind(this));

      if (this.isDesignMode) return;

      const forced = new URLSearchParams(window.location.search).has('popup-newsletter');
      if (!forced && this.getCookie()) return;

      const delay = forced ? 0 : parseInt(this.dataset.delay, 10) || 0;
      setTimeout(() => this.open(), delay * 1000);
    }

    open() {
      this.setAttribute('open', '');
      this.removeAttribute('hidden');
      document.body.classList.add('prevent-scroll');
      if (typeof getScrollbarWidth === 'function') {
        document.body.style.paddingRight = getScrollbarWidth() + 'px';
      }
      if (typeof trapFocus === 'function') trapFocus(this, this.dialog);
      if (!this.isDesignMode) this.setCookie('seen', this.dataset.repeatAfterClose);
    }

    close() {
      if (!this.hasAttribute('open')) return;
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      this.setAttribute('closing', '');
      setTimeout(() => {
        this.removeAttribute('open');
        this.removeAttribute('closing');
        this.setAttribute('hidden', '');
        document.body.classList.remove('prevent-scroll');
        document.body.style.paddingRight = '';
      }, 300);
    }

    async onSubmit(e) {
      e.preventDefault();
      if (this.submitButton.disabled) return;

      const email = this.input.value.trim();
      if (!email || !this.input.checkValidity()) {
        this.showMessage('Adresse email invalide.', 'error');
        this.input.focus();
        return;
      }

      this.setLoading(true);
      this.hideMessage();

      let data;
      try {
        const res = await fetch(this.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email }),
        });
        data = await res.json();
      } catch (err) {
        data = { success: false, message: 'Erreur réseau, réessayez.' };
      }

      this.setLoading(false);

      if (data.status === 'code_sent' || data.status === 'already_subscribed') {
        if (!this.isDesignMode) this.setCookie('subscribed', this.dataset.repeatAfterSubscribe);
        this.formView.hidden = true;
        this.showMessage(data.message, data.status === 'code_sent' ? 'success' : 'info');
        return;
      }

      this.showMessage(data.message || 'Erreur interne, réessayez.', 'error');
    }

    setLoading(isLoading) {
      this.submitButton.disabled = isLoading;
      this.submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      if (isLoading) {
        this.submitLabel = this.submitButton.textContent;
        this.submitButton.textContent = 'Envoi en cours...';
      } else if (this.submitLabel) {
        this.submitButton.textContent = this.submitLabel;
      }
    }

    showMessage(text, type) {
      this.message.className = 'perso-popup-newsletter__message perso-popup-newsletter__message--' + type;
      this.message.textContent = text;
      this.message.hidden = false;
    }

    hideMessage() {
      this.message.hidden = true;
    }

    getCookie() {
      const match = document.cookie.match(new RegExp('(?:^|; )' + this.cookieName + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }

    setCookie(status, days) {
      const maxAge = Math.round((parseFloat(days) || 1) * 86400);
      document.cookie =
        this.cookieName + '=' + encodeURIComponent(status) + '; max-age=' + maxAge + '; path=/; SameSite=Lax';
    }
  }

  customElements.define('perso-popup-newsletter', PersoPopupNewsletter);
}
